module.exports = __webpack_public_path__ + "static/media/linkedin.13c29fdb.svg";